module.exports = __webpack_public_path__ + "static/scale-model-of-tampa-postcard-mural-in-tampa-florida-e5701bf18bf9150e6518f3b35bc7c929.png";